import { render, staticRenderFns } from "./RoleFormView.vue?vue&type=template&id=621f84f0&scoped=true&"
import script from "./RoleFormView.vue?vue&type=script&lang=js&"
export * from "./RoleFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621f84f0",
  null
  
)

export default component.exports